<template>
  <div class="mw-panel">
    <div class="mw-tree-search" v-if="search">
      <el-input
        :placeholder="$lang('请输入搜索内容')"
        v-model="searchText"
        clearable>
      </el-input>
    </div>
    <div :class="{'mw-tree-search__body':search,'mw-tree-no-search__body':!search}">
      <div class="mw-tree">

      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/common/util'
  export default {
    name: 'MwLevelTree',
    props: {
      search:{
        type: Boolean,
        default: false
      },
      //是否自动加载
      autoLoad:{
        type: Boolean,
        default: true
      },
      //默认参数
      defaultParams:{
        type: Object
      },
      //加载数据地址
      url: {
        type: String,
        required: true
      },
      //是否打开第一个节点
      expandedFirst: {
        type: Boolean,
        default: false
      },
      //是否异步加载
      async: {
        type: Boolean,
        default: false
      },
      //是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      singleLeaf: {
        type: Boolean,
        default: false
      },
      //多选是否只选最子节点
      multipleLeaf: {
        type: Boolean,
        default: false
      },
      appendRefresh:{
        type: Boolean,
        default: true
      },
      firstExpandOneLevel:{
        type: Boolean,
        default: false
      },
      //多选时选中的ID
      checkNodes: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //单选选中ID
      selectNode: {
        type: String,
        default: ''
      },
      // 静态数据
      treeData: {
        type: [Array,Object]
      }
    },
    data() {
      return {
        searchFlag:false,
        searchText:'',

        dblClickTrigger:false, //双击触发
        selectTrigger:false, //选中触发
        deselectTrigger:false, //取消选中触发
        checkTrigger:false,  //复选触发

        current_expanded:false, //当前是否已经全部展开完成
        current_expandCount:0,  //当前展开节点数
        current_expand_last_id:'', //当前展开最后一个节点ID
        current_expand_Loaded:false,  //当前展开加载完成后

        initData:[],          //初始化数据
        hasRefreshIds:[],  //已请求过的id
        hasOpenedIds:[],   //已展开过的id
      }
    },
    watch: {
      checkNodes(newIds) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.uncheck_all();
        newIds.forEach(id => {
          let obj = inst.get_node(id);
          inst.check_node(obj);
        })
      },
      selectNode(newId) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
        if (newId) {
          let obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      },
      searchText(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true)
        if(val==''){
          setTimeout(function() {
            tree.clear_search()
          }, 250);
        }else{
          if (this.searchFlag) {
            clearTimeout(this.searchFlag)
          }
          this.searchFlag = setTimeout(function() {
            tree.search(val,true,true)
          }, 250);
        }
      },
      url(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      }
    },
    mounted() {
      if(this.autoLoad){
        this.renderTree();
      }
    },
    destroyed() {
      let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
      if(tree){
        tree.destroy();
      }
    },
    methods: {
      checkAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.select_all();
      },
      unCheckAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
      },
      openAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('open_all');
      },
      closeAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('close_all');
      },
      refresh() {
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      refreshData(data){
        $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      showNode(id){
        let me=this;
        let obj= $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
        $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
      },
      hideNode(id){
        let me=this;
        let tree = $(me.$el.querySelector('.mw-tree')).jstree(true);
        let obj= tree.get_node(id);
        tree.hide_node(obj);
      },
      getSelectNodes(){
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();
        let data=[];
        if (selected.length > 0) {
          selected.forEach(id => {
            var obj=tree.get_node(id);
            if(obj.type=='file' && !obj.state.hidden){
              var d=Object.assign({parentId:obj.parent},obj.original);
              data.push(d);
            }
          });
        }
        return data;
      },
      //获取选中节点原始数据 多选返回列表，单选返回对象
      getSelected() {
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();
        let data=[];
        if (this.multiple) {
          if (selected.length > 0) {
            data = [];
            selected.forEach(id => {
              data.push(tree.get_node(id).original);
            });
          }
        } else {
          if (selected.length > 0) {
            data = tree.get_node(selected[0]).original;
          }
        }
        return data;
      },
      renderTree() {
        let me = this;
        let plugin = ["types"];
        let items = {};
        if (me.multiple) {
          plugin.push("checkbox");
          plugin.push("wholerow");
        } else {
          plugin.push("wholerow");
        }
        if(me.search){
          plugin.push("search");
        }
        let data = me.getData();
        me.buildTree(data, plugin, items);
      },
      getData(){
        let me = this;
        let data = {};
        if(me.treeData) {
          data = me.treeData
          return data;
        }
        data = {
          async: false,
          "url": function (node) {
            let arr = [];
            for(let p in me.defaultParams) {
              arr.push(p + "=" + me.defaultParams[p]);
            }
            if (node.id === '#') {
              return me.url+ '?'+arr.join("&") ;
            } else {
              return me.url + '/' + node.id+ '?'+arr.join("&");
            }
          },
          'data': function (node) {
            return {'id': node.id};
          },
          dataFilter: function (data) {
            var data = JSON.parse(data);
            if(!me.current_expand_Loaded){ //当前展开未加载完成前
              this.loopChildren(data);
            }
            //debugger;
            if(data){
                me.$emit("beforeDataFilter",data);
            }else {
              data = [];
            }
            if(me.current_expand_Loaded){ //第一次加载完成后，把初始化数据和新获取数据组合
                let resData = [];
               this._initData(me.initData,this.data.split('=')[1] , data, resData);
               if (resData.length > 0) {
                return JSON.stringify(resData[0].children);
               }else{
                return JSON.stringify(data);
               }
            }else{
              me.initData=data;
            }
            return JSON.stringify(data);
          },
          _initData(data,appendParentId, appendData,resData){
            if(!data){
                return;
            }
            for(let i=0;i<data.length;i++) {
              let v = data[i];
              if (v.children instanceof Array) {
                if (v.id == appendParentId) {
                  for (let j = appendData.length - 1; j >= 0; j--) {
                    v.children.unshift(appendData[j]);
                  }
                  resData.push(v);
                }else {
                  this._initData(v.children, appendParentId, appendData, resData)
                }
              }
            }
          },
          loopChildren(data){
            data.forEach(d => {
              if(d.children){
                this.loopChildren(d.children);
              }else{
                me.hasRefreshIds.push(d.id);
              }
            })
          },
          "success": function (data) {
            return data;
          }
        }
        return data;
      },
      buildTree(data, plugin, cmenuitems){
        let me = this;
        let jsTreeEl = $(me.$el.querySelector('.mw-tree'));
        jsTreeEl.data('jstree', false).empty();
        jsTreeEl.bind("load_node.jstree", function (e, data) {
          let inst = data.instance;
          let set = inst.settings;
          let node = data.node;
          if(set.async &&  me.expandedFirst) { //异步并且展开第一个节点
            if (node && node.children && !set.expanded_first) { //存在子节点并且还未展开第一个节点
              function open_first_node(node) {
                me.current_expandCount++;
                //console.log("load:"+me.current_expandCount+':'+node);
                if(node && (node.id=="#" || (node.original && node.original.hasChild > 0))) {
                  let n;
                  if(node.children){
                    if(me.firstExpandOneLevel){
                      n = inst.get_node(node.children[0]);
                    }else{
                        //找到下一个存在子节点的节点
                      for (let i = 0; i < node.children.length; i++){
                        let id=node.children[i];
                        let v=inst.get_node(id);
                        if (v.children &&  v.children.length>0) {
                          n = v;
                          break;
                        }
                      }
                    }
                  }
                  if(n){
                    me.hasRefreshIds.push(n.original.id);
                    me.hasOpenedIds.push(n.original.id);
                    me.current_expand_last_id = n.original.id;
                  }
                  inst.open_node(n);
                  open_first_node(n);
                }else{
                  me.current_expanded=true;
                  set.expanded_first = true;
                }
              }
              open_first_node(node);
            }
          }
        }).on("before_open.jstree", function (el,data) {
        }).on("after_open.jstree", function (el,data) {
          let inst = data.instance;
          let set = inst.settings;
          let node = inst.get_node(data.node.id);
          if(me.current_expand_Loaded){ //第一次加载完成后
            if(me.appendRefresh){
              if(node.original && !node.original.hidden && node.original.hasChild != undefined && node.original.hasChild>0) {
                let id = node.original.id;
                if(me.hasRefreshIds.indexOf(id) == -1) {
                  me.hasRefreshIds.push(id);
                  jsTreeEl.jstree(true).refresh_node(node);
                }
              }
            }
            if(me.hasOpenedIds.indexOf(node.original.id)==-1){
              me.hasOpenedIds.push(node.original.id);
            }
          }
          if(node.children){
            node.children.map((v)=>{
              let cn = jsTreeEl.jstree(true).get_node(v);
              if(cn.original && cn.original.hidden){
                jsTreeEl.jstree(true).hide_node(cn);
              }
            });
          }
          if(me.current_expanded){
            me.current_expandCount--;
           // console.log("open:"+me.current_expandCount+':'+node+",current_expand_last_id:"+me.current_expand_last_id);
            if(me.current_expandCount==2){
              me.current_expand_Loaded=true;
              me.current_expanded=false;
            }
          }
        }).on("changed.jstree", function (e, data) {
        }).bind("loaded.jstree", function (e, data) {
          jsTreeEl.delegate(".jstree-checkbox",'mousedown', function (e) {
            // e.stopPropagation();
            //debugger;
            var id = $(this).parent()[0].id;
            let inst =jsTreeEl.jstree(true)
            var obj = inst.get_node(id);
            if(!me.dblClickTrigger) {
              me.checkTrigger = true;
              if (obj.state.selected != undefined) {
                if(obj.state.selected) {
                  // inst.deselect_node(obj);
                } else {
                  //展开其下所有节点并选中
                  var nodeIds = [];
                  var groupIds = [];
                  function getGroupIds(node) {
                    if(node.original && node.original.type != 'file') {
                      if(me.hasOpenedIds.indexOf(node.original.id)==-1){
                        groupIds.push(node.original.id);
                      }
                      nodeIds.push(node.id);
                      var children = node.children;
                      if(children instanceof Array){
                        children.map(v => {
                          let n = inst.get_node(v);
                          getGroupIds(n);
                        })
                      }
                    }
                  }
                  getGroupIds(obj);
                  if(groupIds.length>0){
                    /*var url = me.url;
                    var params = {};
                    params.groupIds = groupIds;
                    util.ajax(url, params).then(res=>{
                      var initData = me.initData;
                      for(var k in res){
                       var ul = res[k];
                       ul.map(d=>{
                          me.hasRefreshIds.push(d.id);
                       });
                        me.$emit("beforeDataFilter",ul);
                        me._appendData(initData, k, ul);
                      }
                      me.refreshData(initData); //刷新勾选上的数据都被取消选中
                      groupIds.map(gId=>{
                          if(me.hasRefreshIds.indexOf(gId)==-1){
                            me.hasRefreshIds.push(gId);
                          }
                      });*/
                      // inst.select_node(obj);
                      inst.open_node(nodeIds);
                   /* });*/
                  }else{
                    // inst.select_node(obj);
                    inst.open_node(nodeIds);
                  }
                }
              }
              me.checkTrigger=false;
            }
          })
        }).bind("click.jstree", function(e, data) {
        }).bind("check_node.jstree", function(e, data) {
        }).bind("dblclick.jstree", function(e, data) {
          /*var id=e.target.id.substr(0,e.target.id.lastIndexOf('_'));
          var obj =  jsTreeEl.jstree(true).get_node(id);
          me.dblClick=true;
          if (obj) {
            if(obj.original.type=='file'){
              function callback(){
                jsTreeEl.jstree(true).hide_node(obj);
              }
              me.$emit("dblClick",obj.original,obj.parent,callback);
            }else{
              if (obj.state.selected) {
                jsTreeEl.jstree(true).deselect_node(obj);
              } else {
                jsTreeEl.jstree(true).select_node(obj);
                if(me.openedIds.indexOf(obj.original.id) == -1){
                  function open_first_node(node) {
                    jsTreeEl.jstree(true).open_node(node);
                    if (!node.original || node.original && node.original.type!='file') {
                      me.openedIds.push(node.original.id);
                      var children=node.children;
                      children.map(v=>{
                        let n = jsTreeEl.jstree(true).get_node(v);
                        jsTreeEl.jstree(true).open_node(n);
                        open_first_node(n);
                      })
                    }
                  }
                  open_first_node(obj);
                }else{
                  if (obj.state.opened && me.multiple) {
                    jsTreeEl.jstree(true).close_node(obj);
                  }
                }
              }
            }
          }
          me.dblClick=false;*/
        }).bind("select_node.jstree", function(e, data) {
          if(!me.checkTrigger && me.multiple){
            if(!me.dblClickTrigger && !me.deselectTrigger){
              if(!me.selectTrigger){
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                me.selectTrigger=true;
                inst.deselect_node(obj);
                me.selectTrigger=false;
              }else{
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                inst.select_node(obj);
              }
            }
          }
        }).bind("deselect_node.jstree", function(e, data) {
          if(!me.checkTrigger && me.multiple) {
              if(!me.dblClickTrigger && !me.selectTrigger){
                if(!me.deselectTrigger) {
                  var inst = data.instance;
                  var obj = inst.get_node(data.node.original.id);
                  me.deselectTrigger = true;
                  inst.select_node(obj);
                  me.deselectTrigger = false;
                }else{
                  var inst = data.instance;
                  var obj = inst.get_node(data.node.original.id);
                  inst.deselect_node(obj);
                }
              }
            }
        }).jstree({
          'async': me.async, //url 是一次性加载，还是异步
          'expanded_first': false,//是否已经展开树节点
          'core': {
            "themes": {
              "responsive": false
            },
            "multiple": me.multiple,  //不允许多选
            "check_callback": function (operation, node, node_parent, node_position, more) {
              return true;
            },
            'data': data
          },
          'checkbox': {
            "keep_selected_style": false,
            "three_state": true,
            "visible": true,
            "tie_selection":true
          },
          "plugins": plugin,
          "contextmenu": {
            "items": cmenuitems
          },
          "types": {
            "#": {
              "icon": "fa fa-folder"
            },
            "file": {
              "icon": "fa fa-leaf"
            },
            "default": {
              "icon": "fa fa-folder"
            }
          },
        })
      }/*,
      _appendData(data,appendParentId, appendData){
        for(let i=0;i<data.length;i++) {
          let v = data[i];
          if(!v.children){
            continue;
          }
          if(v.id==appendParentId){
            if(v.children instanceof Array) {
              for (let j = appendData.length - 1; j >= 0; j--) {
                v.children.unshift(appendData[j]);
              }
            }else{
              v.children=[];
              for (let j = appendData.length - 1; j >= 0; j--) {
                v.children.push(appendData[j]);
              }
            }
          }else{
            this._appendData(v.children, appendParentId, appendData)
          }
        }
      }*/
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/tree/level.vue